import { render, staticRenderFns } from "./targets-rating.vue?vue&type=template&id=00060291&"
import script from "./targets-rating.vue?vue&type=script&lang=js&"
export * from "./targets-rating.vue?vue&type=script&lang=js&"
import style0 from "./targets-rating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports